import React, {useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,
  ListOrderBy,
  ListRowRenderer
} from "../../common/AbstractListView";

import constants from '../../../constants';

import {amsCrHistoryCodeList,} from '../tableSettings';
import {Search} from "../../../filtering";

import {
  DateRenderer,
  DateTimeRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,
  TextAlignRightRenderer,
  TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext from '../../common/JobListViewContext';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import {JobNames} from '../../../framework.core/JobNames';
import {Ams1CHistoryListItem} from '../../../fms.data/models/Ams1CHistoryListItem';
import * as XCol from '../../../framework.core/XExportColumn';

import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';

function ViListCommands() {
  return (
    <>
    </>
  );
}

function ViListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<Ams1CHistoryListItem>) {
  return data;
}

function ViListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return null;
}

/**
 * Concrete implementation for AMS CR History List screen
 *
 * @class CrHistoryListView
 * @extends {AbstractListView}
 */
 class CrHistoryListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, opType :any): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.AMSC1History, 'Ams1CHistoryListItem',
    Ams1CHistoryListItem.calculateSearchParameters(search, Ams1CHistoryListItem.MapSearchFields),
      1,
      search.pageSize,
      'AMS');

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return Ams1CHistoryListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if(x.dataIndex === "status") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: '¨id',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = amsCrHistoryCodeList;
    const cols = Ams1CHistoryListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });

    return tsettings; 
  }

  renderCommands() {
    return (
      <ViListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ViListToolbar />
    );
  }


  renderExtras() {
    return <ViListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  getListViewTitle() {
    return `AMS CR History List`;
  };
  
  hasMemo(): boolean {
    return false;
  }
};

export default CrHistoryListView;